import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosConfig";
import api from "../../../utils/api";
import { Template } from "../../../@types/template";
import { RootState } from "../../rootReducer";

type UpdateTemplateArgs = {
  id: string;
  changes: Partial<Template>; // Solo los campos a modificar
};

export const updateFileTemplate = createAsyncThunk<
  Template,                         // Return type (payload on success)
  UpdateTemplateArgs,               // Argument type
  { state: RootState; rejectValue: string } // ThunkApi config
>(
  "templateUpdate/updateTemplate",
  async ({ id, changes }, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      // Si tu backend necesita saber la organización fuente (igual que en create):
      const payload = {
        ...changes,
        sourceOrganization: state.userAuthentication.user?.sourceOrganization,
      };

      const { data } = await axiosInstance.put(`${api.baseURL}form/${id}`, payload);
      return data as Template;
    } catch (err: any) {
      const msg =
        err?.response?.data?.message ??
        err?.message ??
        "Error actualizando el template";
      return rejectWithValue(msg);
    }
  }
);
